import { render, staticRenderFns } from "./RiasecImageLegend.vue?vue&type=template&id=3dc06cf3&scoped=true&"
import script from "./RiasecImageLegend.vue?vue&type=script&lang=js&"
export * from "./RiasecImageLegend.vue?vue&type=script&lang=js&"
import style0 from "./RiasecImageLegend.vue?vue&type=style&index=0&id=3dc06cf3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc06cf3",
  null
  
)

export default component.exports